import { leaderboardUsers } from "@/models/leaderboardUser.model";
import { Avatar, Box, Flex, Text } from "@radix-ui/themes";
import { FC, JSX } from "react";

import { formatRacingTime } from "../../../../utils/formatRacingTime";

const LeaderboardHero: FC<{ leader?: leaderboardUsers; badge?: string }> = ({
  leader,
  badge = "CURRENT LEADER",
}): JSX.Element | null => {
  if (!leader) return null;

  const team =
    leader.userChallengeData?.gameSpecificData?.teamName ||
    leader.profile?.storeName;

  return (
    <Flex
      className="sr-hero"
      direction="column"
      align="center"
      justify="center"
      gap="4"
      p="6"
    >
      <Box className="sr-hero__pos">P1</Box>

      <Text className="sr-hero__badge gradient" size="3" weight="bold">
        {badge}
      </Text>

      <Avatar
        className="sr-hero__avatar"
        radius="full"
        size="7"
        src={leader.profile.avatarUrl}
        fallback={leader.profile.userName?.[0] ?? "?"}
      />

      <Flex direction="column" align="center" gap="1">
        <Text size="6" weight="bold" style={{ color: "white" }}>
          {leader.profile.userName}
        </Text>
        {team && (
          <Text size="2" className="sr-hero__team">
            {team}
          </Text>
        )}
      </Flex>

      <Flex direction="column" align="center" gap="1">
        <Text size="1" className="sr-hero__caption">
          FASTEST LAP
        </Text>
        <Text className="sr-hero__time sr-time gradient">
          {formatRacingTime(leader.userChallengeData?.points)}
        </Text>
      </Flex>
    </Flex>
  );
};

export default LeaderboardHero;
